import { useEffect, useRef } from "react";

export const PE = (progress = null, error = null) => ({ progress, error });

export const PES = (success = false, progress = null, error = null) => ({
  progress,
  error,
  success,
});

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const PEV = (value, progress = null, error = null) => ({ progress, error, value });

export const renderWithStyle = (props, children) => ({ props, children });

export const objectType = "object";
export const functionType = "function";

export const firstOrDefault = (array, defaultValue) =>
  array.length > 0 ? firstValue(array) : defaultValue;

export const firstOrNull = (arr) => firstOrDefault(arr, null);

export const arrOrDefault = (arr, defaultValue) => (isEmptyArray(arr) ? defaultValue : arr);

export const arrOrFirstOrNull = (arr) => (arr.length > 1 ? arr : firstOrNull(arr));

export const firstValue = (array) => array[0];

export const isNullOrUndefinedOrEmpty = (obj, checkEmptyString = false) =>
  isNullOrUndefined(obj) ||
  isEmpty(obj) ||
  (checkEmptyString && typeof obj === "string" && isEmptyString(obj));

export const isNullOrUndefined = (obj) => obj == null || obj === undefined;

export const isEmptyObjOrFn = (objOrfn) => {
  return typeof objOrfn === objectType && typeof objOrfn !== functionType
    ? isEmptyObject(objOrfn)
    : false;
};

export const isEmpty = (objOrfnOrArr) =>
  Array.isArray(objOrfnOrArr) ? isEmptyArray(objOrfnOrArr) : isEmptyObjOrFn(objOrfnOrArr);

export const isEmptyObject = (obj) => eq(Object.keys(obj).length, 0);

export const isEmptyArray = (arr) => arr.length === 0;

export const eq = (a, b) => a === b;

export const isEmptyString = (stringToCheck, ignoreSpaces = true) =>
  (ignoreSpaces ? stringToCheck.trim() : stringToCheck) === "";

export const isNullOrEmptyString = (stringToCheck, ignoreSpaces = true) =>
  !stringToCheck || (ignoreSpaces ? stringToCheck.trim() : stringToCheck) === "";

export const isLocal = (env) => env === "development";

export const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

export const run = (runnable, ...collection) => Promise.all(collection.map(runnable));

export const excludeNullPropertiesFromArr = (arr) => {
  return arr.map((obj) =>
    Object.entries(obj).reduce(
      (object, [key, value]) =>
        isNullOrUndefinedOrEmpty(value) ? object : { ...object, [key]: value },
      {},
    ),
  );
};

export const excludePropertyFromArr = (arr, propertyName) => {
  return arr.map((obj) =>
    Object.entries(obj).reduce(
      (object, [key, value]) => (key === propertyName ? object : { ...object, [key]: value }),
      {},
    ),
  );
};

export const sort = (arr, key) =>
  arr.sort((o1, o2) => {
    return o1[key].localeCompare(o2[key]);
  });

export const watcher = (valueSelector, compare) => {
  const defaultCompare = (a, b) => a === b;
  compare = compare || defaultCompare;
  let currentValue = valueSelector();
  return function w(fn) {
    const newValue = valueSelector();
    if (!compare(currentValue, newValue)) {
      const oldValue = currentValue;
      currentValue = newValue;
      fn(oldValue, newValue);
    }
  };
};

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export function isTableDataAvailable(dataSource) {
  return !isNullOrUndefined(dataSource) && !isEmptyArray(dataSource);
}

export const getTableContainerHeight = () =>
  document.getElementsByClassName("ant-tabs-content-holder")[0].clientHeight;
export const getTableElement = (id) => document.getElementById(id);
export const getTableHeaderHeight = (parentTableElement) =>
  parentTableElement.getElementsByClassName("ant-table-thead")[0]?.clientHeight ?? 0;
export const getSubmitNoticeHeight = (submitBoardId) =>
  document.getElementById(submitBoardId)?.clientHeight ?? 0;
export const getTablePaginationHeight = (parentTableElement) => {
  const element = parentTableElement.parentNode.getElementsByClassName("ant-pagination")[0];
  if (element) {
    return element.clientHeight + element.offsetHeight;
  }
  return 0;
};

export var globalVar = {};
export const refreshTimeout = 1000;

export const firstUpperCase = (str) =>
  str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());

export function inProgress(value) {
  if (value === null) {
    return false;
  } else {
    return true;
  }
}

export function isArrayEqual(array1, array2) {
  const arr1=array1.slice();
  const arr2=array2.slice();
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false;
  }
  if (isEmptyArray(arr1) && isEmptyArray(arr2)) {
    return true;
  }
  const lengthOfArr1 = arr1.length;
  const lengthOfArr2 = arr2.length;
  if (lengthOfArr1 !== lengthOfArr2) {
    return false;
  }
  arr1.sort();
  arr2.sort();
  for (let count = 0; count <= lengthOfArr1; count++) {
    if (arr1[count] !== arr2[count]) {
      return false;
    }
  }
  return true;
}

export const  plainObject = (obj) => JSON.parse(JSON.stringify(obj));

export const appendDotToString = (str) => `.${str}`;

export function convertToArray(value) {
  return !Array.isArray(value) ? [value] : value;
}
